import { Reveal } from "../motion/Reveal";
import { AnimatedText } from "../motion/AnimatedText";
import { useC } from "../../context/SiteData";

export const PageHero = ({ title, subtitle, desc }) => {
  const c = useC();
  return (
    <section data-testid="page-hero" className="border-b border-line bg-cream-100">
      <div className="container-x pb-16 pt-32 sm:pb-24 sm:pt-44">
        <Reveal>
          <p className="label flex items-center gap-3 text-ink-500">
            <span className="inline-block h-px w-8 bg-ink-400" />
            {c.pagehero_label}
          </p>
        </Reveal>
        <h1
          className="mt-5 text-5xl font-bold leading-[1.05] tracking-tight text-ink-900 sm:text-6xl lg:text-7xl"
          data-testid="page-hero-title"
        >
          <AnimatedText text={title} delay={0.1} stagger={0.045} byLetter immediate />
        </h1>
        {subtitle && (
          <Reveal delay={0.3}>
            <p className="mt-5 text-xl font-semibold tracking-tight text-ink-800 sm:text-2xl" data-testid="page-hero-subtitle">
              {subtitle}
            </p>
          </Reveal>
        )}
        {desc && (
          <Reveal delay={0.4}>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-ink-500 sm:text-lg">
              {desc}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
};
